<header class="demande-header">
  <button
    type="button"
    class="demande-header__btn"
    [attr.aria-label]="'UX_TEXT.DEMANDE.HEADER.BACK_ARIA' | translate"
    (click)="backPressed.emit()"
  >
    <ion-icon name="chevron-back-outline"></ion-icon>
  </button>

  <div class="demande-header__center">
    <h1 class="demande-header__title">{{ title }}</h1>
    <span class="demande-header__badge" *ngIf="domain">
      <ion-icon name="construct-outline"></ion-icon>
      {{ domain }}
    </span>
  </div>

  <button
    type="button"
    class="demande-header__btn"
    [attr.aria-label]="'UX_TEXT.DEMANDE.HEADER.CLOSE_ARIA' | translate"
    (click)="closePressed.emit()"
  >
    <ion-icon name="close-outline"></ion-icon>
  </button>
</header>
